
import * as React from "react";
import { SvgIcon, SvgIconProps } from "@material-ui/core"
import { forwardRef } from "react";


export const SmallCross: React.FC<SvgIconProps> = forwardRef(({...props}, ref) => {
  return (
    <SvgIcon {...props} viewBox="0 0 11.414 11.414" innerRef={ref}>
      <path id="Крестик" d="M5,5,0,10,5,5,0,0,5,5l5-5L5,5l5,5Z" transform="translate(0.707 0.707)" fill="currentColor" stroke="currentColor" strokeWidth="2"/>
    </SvgIcon>
  );
})

export default SmallCross;